// libraries
import parse from "html-react-parser"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

// components & functions
import { apiClient } from "../../core/api_client"
import Breadcrumb from "../../components/Breadcrumb"

// assets
import captcha from "../../../assets/img/utils/captcha.svg"
import support from "../../../assets/img/utils/support.png"
import close from '../../../assets/img/projects/close.svg'

const Contact1 = () => {
	const [name, setName] = useState("");
	const [surname, setSurname] = useState("");
	const [patronymic, setPatronymic] = useState("");
	const [address, setAddress] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");

	const { t } = useTranslation();

	const breadcrumb = [
		{
			id: 1,
			link: "/elaqe/cagri-merkezi",
			title: t('contact:cagri'),
			isActive: false,
		},
		{
			id: 2,
			link: "/elaqe/elaqe-vasiteleri",
			title: t("contact:contact"),
			isActive: true,
		},
		{
			id: 3,
			link: "/elaqe/metbuat-xidmeti",
			title: t("contact:press"),
			isActive: false,
		},
		{
			id: 4,
			link: "/elaqe/en-cox-verilen-suallar",
			title: t("contact:faq"),
			isActive: false,
		},
	];

	const [isSending, setIsSending] = useState(false);
	const [popupVisible, setPopupVisible] = useState(false);
	const [popupMessage, setPopupMessage] = useState('');

	const viewPopupMessage = (message) => {
		setPopupVisible(true);
		setPopupMessage(message);
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (isSending) return;
		setIsSending(true);

		const data = {
			name: name,
			surname: surname,
			patronymicName: patronymic,
			address: address,
			phone: phone,
			email: email,
			text: message,
		};

		await apiClient.post(`/sendEmail`, data).then((res) => {
			if (res.status === 200) {
				// alert(t("contact:message_sent"));
				viewPopupMessage(t("contact:message_sent"));
			} else {
				viewPopupMessage(t("contact:message_error"));
			}
		});

		setIsSending(false);
		setName("");
		setSurname("");
		setPatronymic("");
		setAddress("");
		setPhone("");
		setEmail("");
		setMessage("");
	};

	const [isLoading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(false);
	}, []);

	return (
		<div className="contact-page block-bg1 pt-lg-3 pb-3 position-relative">
			<Breadcrumb data={breadcrumb} />
			<div className={'position-absolute w-100 h-100 top-0 start-0 justify-content-center ' + (popupVisible ? "d-flex" : "d-none")} style={{ background: "rgba(34, 50, 74, 0.4)", zIndex: 10000 }}>
				<div className='note-card rounded-2 position-fixed my-auto' style={{ transform: "translate(0%, 90%)", bottom: "70%", maxWidth: "75%", backgroundColor: "white" }}>
					<div className="rounded-circle ms-auto cursor p-3 position-absolute bg-white" onClick={() => setPopupVisible(false)} style={{ right: '-7%', top: '-15%' }}>
						<img src={close} alt="close" />
					</div>
					<div className="block-bg3 rounded-top-2" style={{ height: '60px' }}></div>
					<div className="d-flex align-items-center text-wrap p-3">
						<h5 className='t-color2 fw-500 text-center mb-4 p-3'>{popupMessage && popupMessage}</h5>
					</div>
				</div>
			</div>
			<div className="container mt-4 mt-sm-5">
				<div className="row">
					<div className="col-12 col-sm-6">
						<div className="my-3">
							<p className="mb-1">{t("contact:address_h")}</p>
							<p className="t-color5">{parse(t("contact:address_1"))}</p>
							<div className="d-flex align-items-center my-1">
								<h5 className="t-color5 fw-normal">{t('contact:cagri')}</h5>
								<img src={support} alt="Support" className="col-1 mb-2 ms-2" />
							</div>
							<p className="t-color5">{parse(t("contact:address_2"))}</p>

						</div>
						<div className="my-5">
							<p className="mb-1">{parse(t("contact:mida_mmc"))}</p>
							<p style={{ color: "#5B687C" }}>{parse(t("contact:address_1"))}</p>
							<div className="d-flex align-items-center my-1">
								<h5 className="t-color5 fw-normal">{t('contact:cagri')}</h5>
								<img src={support} alt="Support" className="col-1 mb-2 ms-2" />
							</div>
							<p style={{ color: "#5B687C" }}>{parse(t("contact:address_2"))}</p>
						</div>
					</div>
					<div className="col-sm-6 col-12">
						{isLoading && (
							<div
								className=" d-flex justify-content-center align-items-center"
								style={{ height: "20rem" }}
							>
								<div className="lds-roller">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						)}
						{!isLoading && (
							<iframe
								className="w-100 rounded-3"
								title="Mənzil İnşaatı Dövlət Agentliyi"
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d936.3338288353203!2d49.84368458935926!3d40.3828732716931!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d7e055043af%3A0x2b264c5c5e80b41b!2zTcmZbnppbCDEsG7Fn2FhdMSxIETDtnZsyZl0IEFnZW50bGl5aQ!5e0!3m2!1sen!2saz!4v1688734424793!5m2!1sen!2saz"
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"
							></iframe>
						)}
					</div>
				</div>

				<h1 className="text text-center section-heading my-4">
					{t("contact:el_message")}
				</h1>

				<p className="text-justify t-color5" style={{ lineHeight: "29px" }}>
					{parse(t("contact:el_message_text"))}
				</p>

				<form className="my-4" onSubmit={handleSubmit}>
					<div className="row">
						<div className="col-md-6 col-12">
							<div className="mb-3">
								<label htmlFor="name" className="form-label">
									{t("contact:name")}*
								</label>
								<input
									type="text"
									className="form-control p-2"
									id="name"
									placeholder={t("contact:name")}
									required
									value={name}
									onChange={(e) => setName(e.target.value)}
								/>
							</div>
							<div className="mb-3">
								<label htmlFor="surname" className="form-label">
									{t("contact:surname")}*
								</label>
								<input
									type="text"
									className="form-control p-2"
									id="surname"
									placeholder={t("contact:surname")}
									required
									value={surname}
									onChange={(e) => setSurname(e.target.value)}
								/>
							</div>
							<div className="mb-3">
								<label htmlFor="patronymic" className="form-label">
									{t("contact:patronymic")}*
								</label>
								<input
									type="text"
									className="form-control p-2"
									id="patronymic"
									placeholder={t("contact:patronymic")}
									required
									value={patronymic}
									onChange={(e) => setPatronymic(e.target.value)}
								/>
							</div>
							<div className="mb-3">
								<label htmlFor="address" className="form-label">
									{t("contact:adres")}*
								</label>
								<input
									type="text"
									className="form-control p-2"
									id="address"
									placeholder={t("contact:adres")}
									required
									value={address}
									onChange={(e) => setAddress(e.target.value)}
								/>
							</div>
						</div>

						<div className="col-md-6 col-12">
							<div className="mb-3">
								<label htmlFor="phone" className="form-label">
									{t("contact:phone")}*
								</label>
								<input
									type="text"
									className="form-control p-2"
									id="phone"
									placeholder={t("contact:phone")}
									required
									value={phone}
									onChange={(e) => setPhone(e.target.value)}
								/>
							</div>
							<div className="mb-3">
								<label htmlFor="email" className="form-label">
									{t("contact:email")}
								</label>
								<input
									type="email"
									className="form-control p-2"
									id="email"
									placeholder={t("contact:email")}
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</div>
							<div className="mb-3">
								<label htmlFor="message" className="form-label">
									{t("contact:letter_text")}*
								</label>
								<textarea
									className="form-control p-2"
									id="message"
									rows={5}
									maxlength="1500"
									placeholder={t("contact:letter_text")}
									style={{ resize: "none" }}
									required
									value={message}
									onChange={(e) => setMessage(e.target.value)}
								/>
							</div>
						</div>
					</div>
					<div className="d-flex justify-content-end align-items-center mt-3 col-md-6 ms-auto">
						<div className="form-check mx-2">
							<input
								type="checkbox"
								className="form-check-input"
								id="exampleCheck1"
								required
							/>
							<label className="form-check-label" htmlFor="exampleCheck1">
								{t("contact:not_robot")}
							</label>
						</div>
						<img src={captcha} alt="captcha-logo" className="mx-4" />
						<button
							id="send-btn"
							type="submit"
							className="btn btn-custom py-2"
							style={{ cursor: isSending ? "not-allowed" : "pointer" }}
						>
							{t("contact:send")}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Contact1;